import _classCallCheck from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/buddy/okroo-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';

var View =
/*#__PURE__*/
function (_React$Component) {
  _inherits(View, _React$Component);

  function View(props) {
    var _this;

    _classCallCheck(this, View);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(View).call(this, props));

    if ((this instanceof View ? this.constructor : void 0) === View) {
      throw new TypeError("Cannot construct View instances directly");
    }

    _this.subscriptions = [];
    _this.toBeSubscribed = [];
    _this.hasBeenUnmounted = false;
    return _this;
  }
  /**
   * Subscribe to an Event in a Store
   * This is a helpfull method to keep track of your subscriptions on UnMount and Mount of the Component
   * @param store The Store object where we want to subscribe to, must be a subclass of v2/Store
   * @param eventName The Event Name to which you want to subscribe
   * @param subscriber The subscriber function that's gonna be executed when it happends
   * @param receiveLastValue Whether the subscriber
   * @return subscription The subscription for this event in the Store
   * @throws an Error if the event does not exists in the Store
   * @throws an Error if the subscriber is not a function
   */


  _createClass(View, [{
    key: "subscribe",
    value: function subscribe(store, eventName, subscriber) {
      var receiveLastValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var subscription = store.subscribe(eventName, subscriber, receiveLastValue);
      this.toBeSubscribed.push({
        store: store,
        eventName: eventName,
        subscriber: subscriber,
        receiveLastValue: receiveLastValue
      });
      this.subscriptions.push(subscription);
      return subscription;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.hasBeenUnmounted) return;
      var that = this;
      this.toBeSubscribed.forEach(function (info) {
        var subscription = info.store.subscribe(info.eventName, info.subscriber, info.receiveLastValue);
        that.subscriptions.push(subscription);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
      this.subscriptions = [];
      this.hasBeenUnmounted = true;
    }
  }]);

  return View;
}(React.Component);

export default View;